export const BROADCAST_EVENT =
  "Illuminate\\Notifications\\Events\\BroadcastNotificationCreated";

export const PRIVATE_USER_BROADCAST_CHANNEL = "private-App.Models.User.";
